import { SearchHeader, type SearchHeaderProps } from './searchHeader'

export { SearchHeader }
export type { SearchHeaderProps }
export default SearchHeader
